import { gql } from '@apollo/client';

export const UPSERT_MY_DRIVER_ROUTE_START_END_POINT = gql`
  mutation UpsertMyDriverRouteStartEndPoint($input: UpsertMyDriverRouteStartEndPointInput!) {
    upsertMyDriverRouteStartEndPoint(input: $input) {
      id
      accountId
      start {
        country
        state
        city
        district
        detailAddress
        latitude
        longitude
        standardizedAddress
      }
      end {
        country
        state
        city
        district
        detailAddress
        latitude
        longitude
        standardizedAddress
      }
    }
  }
`;

export interface DriverRouteEndPointAddressInput {
  country: string;
  state: string;
  city: string;
  district?: string | null;
  detailAddress: string;
  latitude?: number | null;
  longitude?: number | null;
}

export interface DriverRouteEndPointAddressResponse extends DriverRouteEndPointAddressInput {
  standardizedAddress?: string | null;
}

export interface UpsertMyDriverRouteStartEndPointInput {
  start?: DriverRouteEndPointAddressInput | null;
  end?: DriverRouteEndPointAddressInput | null;
}

export interface UpsertMyDriverRouteStartEndPointVariables {
  input: UpsertMyDriverRouteStartEndPointInput;
}

export interface UpsertMyDriverRouteStartEndPointResponse {
  upsertMyDriverRouteStartEndPoint: {
    id: string | number;
    accountId: string | number;
    start: DriverRouteEndPointAddressResponse;
    end: DriverRouteEndPointAddressResponse;
  };
}

